import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { LoaderModule } from 'libs/common/src/loader';
import { NeedHelpBottomSheetComponent } from './need-help-bottom-sheet.component';
import { NeedHelpDirective } from './need-help.directive';

@NgModule({
  declarations: [NeedHelpBottomSheetComponent, NeedHelpDirective],
  imports: [
    CommonModule,
    MatButtonModule,
    UtilsModule,
    LoaderModule,
    FontAwesomeModule,
    IconUiModule,
  ],
  exports: [NeedHelpDirective, NeedHelpBottomSheetComponent],
})
export class NeedHelpModule {}
